import React                      from 'react' ;


export const ProductLogo: React.FC< { className?: string } > = ( props ) =>
  <div id="product-logo" className={ props.className || '' } />


export const CorporativeLogo: React.FC = () =>
  <div className="corporative-logo" />